import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationConstants } from "../constants";
import { notificationActions } from "../actions";

function useNotificationListPageHook() {
    // Variables
    const debounceRef = useRef(null);
    const SEND_DELAY = 500; // milliseconds
    const dispatch = useDispatch();

    // States
    const [ filter_activites, set_filter_activites] = useState(false);

    // Redux
    const {
        unselected_organization_ids,
        unselected_workspace_ids,
        id: filter_id,
        selected_filter
    } = useSelector(state => state.notification_filter);

    const {
        deleted_notification,
        updated_notification,
        notification_load
    } = useSelector(state => state.notification);

    // States
    useEffect(() => {
        if(filter_id){
            const refreshNotifications = () => {
                const filter_type = null;
                const filter = selected_filter === null ? null : selected_filter;
                const filterWorkspaceOnInitialize = false
                const lastNotificationId = null;


                const onSuccess = (data) => {
                    if (lastNotificationId) {
                        dispatch({ type: notificationConstants.APPEND_NOTIFICATION_LIST, payload: data.data })
                        dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST_HAS_MORE, payload: data.data.length > 0 })
                    } else {
                        console.log(data)
                        dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST, payload: data.data })
                        dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST_HAS_MORE, payload: data.has_next_page })
                    }
                }

                dispatch(notificationActions.getPage({
                                                        only_unread: filter_activites, 
                                                        lastNotificationId, 
                                                        onSuccess, 
                                                        filter_type, 
                                                        filter,
                                                        filterWorkspaceOnInitialize,
                                                        unselected_organization_ids,
                                                        unselected_workspace_ids
                                                    }))
            }

            const sendSelection = (formData = {}, id) => {
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current);
                }
                debounceRef.current = setTimeout(async () => {
                    console.log('unselected_workspace_ids', unselected_workspace_ids);
                    console.log('unselected_organization_ids', unselected_organization_ids);

                    refreshNotifications();
                }, SEND_DELAY);
            }

            sendSelection({
                unselected_workspace_ids,
                unselected_organization_ids
            },filter_id);
        }
    }, [
        unselected_workspace_ids,
        unselected_organization_ids
    ]);

    useEffect(() => {
        if(deleted_notification){
            dispatch({ type: notificationConstants.DELETE_NOTIFICATION_LIST_ITEM, payload: deleted_notification })
        }
    }, [deleted_notification]);


    useEffect(() => {
        if(updated_notification){
            dispatch({ type: notificationConstants.UPDATE_NOTIFICATION_LIST_ITEM, payload: updated_notification })
        }
    }, [updated_notification]);

    useEffect(() => {
        if (notification_load && filter_activites) {
            dispatch({ type: notificationConstants.UPDATE_NOTIFICATION_LIST_ITEM_AND_UNREAD, payload: notification_load })
        }
    }, [notification_load, filter_activites]);
    
    return {
        filter_activites,
        set_filter_activites
    };
}

export default useNotificationListPageHook;